import BgaImg from "../assets/img/projects/5-IFU-BGA_1-2.png";
import BcaImg from "../assets/img/projects/finecheck bca.png";
import HbImg from "../assets/img/projects/Softstyle hb.png";
import HematologyImg from "../assets/img/projects/finechek 3P.avif";
import DH76Img from "../assets/img/projects/finechek DH76.png";
import UltraImg from "../assets/img/add/ultra.png";

const products = [
  {
    slug: "bga-100",
    name: "Finechek BGA 100",
    tagline: "Blood Gas & Electrolyte Analyzer",
    shortDescription:
      "A handheld blood gas analyzer that delivers lab-quality, diagnostic results in minutes.",
    description:
      "The Finechek BGA 100 is a handheld blood analyzer built for point-of-care testing, delivering lab-quality diagnostic results at the patient's side, out in the field, or in the exam room. Testing takes just three simple steps and only 2-3 drops of whole blood, with a full report ready in 4 minutes.",
    img: BgaImg,
    alt: "Finechek BGA 100 handheld blood gas and electrolyte analyzer",
    brochureHref:
      "/products/Finechek BGA 100/finecheck  BGA 100 bronchure.pdf",
    brochureLabel: "BGA 100 Brochure",
    keyFeatures: [
      { title: "Easy operation", text: "Testing can be performed in 3 simple steps at the patient's side with only 2-3 drops of whole blood." },
      { title: "Handheld portability", text: "Lightweight with a built-in battery, allowing diagnosis at the point of care, patient side, out in the field, or in an exam room." },
      { title: "Fast results", text: "Get accurate results in 4 minutes at the patient's side to enable rapid decision-making and optimize patient care." },
      { title: "Multi-parameter card", text: "A single-use test card offers a broad menu of tests on one portable platform, with a unique combination of biosensors for a wide range of clinical needs." },
    ],
    specs: [
      { label: "Sample", value: "Arterial or venous whole blood" },
      { label: "Sample volume", value: "100 µL" },
      { label: "Measured parameters", value: "Na+, K+, Cl-, Ca2+, pH, pCO2, pO2, Hct, Glu, Lac" },
      { label: "Results in", value: "4 minutes" },
      { label: "Display", value: "4.3\" IPS touch screen" },
      { label: "Printer", value: "Built-in thermal printer" },
      { label: "Battery", value: "3.7V, 5000mAh (up to 360 hours standby)" },
      { label: "Connectors", value: "Type-C" },
      { label: "Bar code", value: "QR code" },
      { label: "Weight", value: "600g" },
      { label: "Operating temperature", value: "5 - 32°C; Relative humidity ≤ 85%" },
    ],
  },
  {
    slug: "bca-100",
    name: "Finechek BCA-100",
    tagline: "Benchtop Chemistry Analyzer",
    shortDescription:
      "A fully automated biochemistry analyzer from Goldsite Diagnostics Inc, its a benchtop analyzer.",
    description:
      "The Finechek BCA-100 is a fully automated benchtop chemistry analyzer designed for a minimal lab footprint without compromising reliability. It combines an 8x10 reaction position with real-time temperature monitoring, a 24-hour reagent cooling system, and QR-code reagent auto-identification, all controlled from a built-in PC with a touch-screen interface. The system is ISO 9001 and ISO 13485:2016 certified, CE marked, and IVD compliant.",
    img: BcaImg,
    alt: "Finechek BCA-100 automated benchtop biochemistry analyzer",
    brochureHref:
      "/products/Finechek BCA 100/Finecheck BCA 100 bronchure.pdf",
    brochureLabel: "BCA 100 Brochure",
    keyFeatures: [
      { title: "Minimal footprint", text: "Compact benchtop design built to save space in smaller labs." },
      { title: "24-hour cooling system", text: "Continuous reagent cooling protects sample and reagent integrity around the clock." },
      { title: "Automatic sampling probe", text: "Liquid level detection and collision protection reduce operator error and downtime." },
      { title: "Smart indicator", text: "A green smart indicator light confirms correct sample loading at a glance." },
    ],
    specs: [
      { label: "Reaction positions", value: "8 × 10" },
      { label: "Interface", value: "Built-in PC with touch screen" },
      { label: "Reagent identification", value: "QR code reagent auto-identification system" },
      { label: "Sample loading", value: "Green smart indicator for sample loading" },
      { label: "Reagent cooling", value: "24-hour reagent cooling system" },
      { label: "Certifications", value: "ISO 9001, ISO 13485:2016, CE, IVD" },
    ],
  },
  {
    slug: "hb-meter",
    name: "SoftStyle Hb Testing System",
    tagline: "Hemoglobin Testing System",
    shortDescription:
      "The Softstyle Hemoglobin Testing System monitors hemoglobin levels with easy data management.",
    description:
      "The SoftStyle Hb Hemoglobin Testing System gives an accurate hemoglobin reading from a single drop of blood in 10 seconds or less, making it well suited to blood donation screening, anemia checks, and routine point-of-care monitoring. Results and up to 1,000 records can be reviewed on-device or exported over USB or optional Bluetooth for easy data management.",
    img: HbImg,
    alt: "SoftStyle Hb handheld hemoglobin testing system",
    brochureHref:
      "/products/Softstyle HB Meter/Softstyle Hemoglobin Testing System.pdf",
    brochureLabel: "HB Meter Brochure",
    keyFeatures: [
      { title: "Fast", text: "Test time of 10 seconds or less, from a sample volume of just 10 µl." },
      { title: "Wide range", text: "Hemoglobin measurement range of 3.0-25.6 g/dL (30-256 g/L or 1.86-15.9 mmol/L)." },
      { title: "On-device memory", text: "Stores up to 1,000 records, with USB and optional Bluetooth connectivity for data export." },
      { title: "Long battery life", text: "Rated for up to 360 hours of battery life between charges." },
    ],
    specs: [
      { label: "Test time", value: "≤ 10 seconds" },
      { label: "Sample volume", value: "10 µl" },
      { label: "Units of measurement", value: "g/dL, g/L, mmol/L" },
      { label: "Hb measurement range", value: "3.0-25.6 g/dL (30-256 g/L or 1.86-15.9 mmol/L)" },
      { label: "Hct range (calculated)", value: "9% - 76.8%" },
      { label: "Strip storage temperature", value: "2 - 30°C" },
      { label: "Operating conditions", value: "10 - 40°C, ≤ 90% RH" },
      { label: "Battery life", value: "360 hours" },
      { label: "Memory", value: "1,000 records" },
      { label: "Connectivity", value: "USB; Bluetooth (optional)" },
    ],
  },
  {
    slug: "finechek-3p",
    name: "Finechek 3P",
    tagline: "3-Part Hematology Analyzer",
    shortDescription:
      "Finechek 3P helps diagnose and monitor blood disorders and quickly provides accurate blood test results.",
    description:
      "The Finechek 3P is a compact 3-part hematology analyzer that reports 21 parameters across WBC, RBC, and PLT from just 9 µL of sample, using impedance counting and cyanide-free colorimetry for HGB. A 10.4-inch touchscreen, built-in thermal printer, and Wi-Fi/LIS connectivity make it suited to small and mid-sized labs that need reliable results without a large footprint.",
    img: HematologyImg,
    alt: "Finechek 3P 3-part hematology analyzer",
    brochureHref:
      "/products/Finechek 3P/Finechek 3-Part Hematology Analyzer.pdf",
    brochureLabel: "Finechek 3P Brochure",
    keyFeatures: [
      { title: "Compact design", text: "Small footprint with a built-in thermal printer and built-in lyse position to save space in small labs." },
      { title: "Reliable performance", text: "Pulse base-line signal tracing technology gives a wider linearity range and more stable results." },
      { title: "Cost-effective", text: "Low sample volume and reagent consumption, a good choice for patients with blood collection difficulties." },
      { title: "Humanized design", text: "Wi-Fi for LIS communication, multiple peripheral interfaces, and a 10.4\" TFT touch screen." },
    ],
    specs: [
      { label: "Principles", value: "Impedance method for WBC, RBC and PLT; cyanide-free colorimetry for HGB" },
      { label: "Parameters", value: "21 reportable parameters (WBC, Gran#, Lym#, Mid#, Gran%, Lym%, Mid%, RBC, HGB, HCT, MCV, MCH, MCHC, RDW-SD, RDW-CV, PLT, MPV, PDW, PCT, P-LCR, P-LCC) plus 3 histograms" },
      { label: "Sample volume", value: "9 µL" },
      { label: "Sample mode", value: "Whole blood, capillary whole blood and pre-diluted modes" },
      { label: "Display", value: "10.4\" TFT touch screen" },
      { label: "Throughput", value: "Up to 60 tests per hour" },
      { label: "Storage", value: "Up to 500,000 records" },
      { label: "Interface", value: "4 USB ports, 1 LAN port; bi-directional LIS support" },
      { label: "Dimensions", value: "270(W) × 375(D) × 350(H) mm" },
      { label: "Net weight", value: "16kg" },
      { label: "Power requirement", value: "100-240V~, 50/60Hz" },
    ],
  },
  {
    slug: "dh76",
    name: "Finechek DH76",
    tagline: "5-Part Auto Hematology Analyzer",
    shortDescription:
      "Finechek DH76 is a fully automatic 5-part hematology analyzer built for high-throughput labs that need fast, reliable blood counts.",
    description:
      "The Finechek DH76 is a fully automatic 5-part hematology analyzer that reports 25 parameters from just 20 µL of sample, using electrical impedance for WBC/RBC/PLT, cyanide-free colorimetry for HGB, and laser-based flow cytometry for WBC differentiation. It loads up to 60 samples at once and runs up to 90 tests per hour, with bi-directional LIS connectivity for labs that need higher throughput than a 3-part analyzer.",
    img: DH76Img,
    alt: "Finechek DH76 5-part automatic hematology analyzer",
    brochureHref: "/products/Finechek DH76/EN-DH76-brochure Finechek.pdf",
    brochureLabel: "Finechek DH76 Brochure",
    keyFeatures: [
      { title: "High throughput", text: "Loads up to 60 samples simultaneously with continuous loading, running up to 90 tests per hour." },
      { title: "Fully automatic intelligent technology", text: "Visual self-tests, automatic test re-run with built-in rules, one-button error removal, and intelligent WBC/RBC/PLT floating threshold technology." },
      { title: "3D scattergram", text: "A rotatable 3D scattergram plus 2D scattergrams for accurate WBC differentiation and pathological sample flagging." },
      { title: "Excellent data management", text: "Up to 20 user-defined pathological alarm ranges, customizable report templates, and bi-directional LIS connection." },
    ],
    specs: [
      { label: "Principles", value: "Electrical impedance (WBC/BAS, RBC/PLT); cyanide-free colorimetry (HGB); laser-based flow cytometry (WBC differentiation)" },
      { label: "Parameters", value: "25 reportable parameters plus 4 research parameters (ALY#, ALY%, LIC#, LIC%); 3 histograms and 1 3D + 2 2D scattergrams" },
      { label: "Sample volume", value: "20 µL" },
      { label: "Sample mode", value: "Whole blood, capillary whole blood and pre-diluted modes" },
      { label: "Throughput", value: "Up to 90 tests per hour" },
      { label: "Storage", value: "Up to 150,000 records" },
      { label: "Communication", value: "LAN port, HL7 protocol, bi-directional LIS support" },
      { label: "Dimensions", value: "650mm(W) × 550mm(H) × 610mm(D)" },
      { label: "Net weight", value: "57.5kg" },
      { label: "Power requirement", value: "100-240V, 50/60Hz, ≤200VA" },
    ],
  },
  {
    slug: "softstyle-ultra",
    name: "Softstyle Ultra 2.0",
    tagline: "Blood Glucose Meter",
    shortDescription:
      "Softstyle Ultra is a blood glucose monitoring system designed to help you monitor your blood glucose levels, suitable for both self-testing and professional use.",
    description:
      "The Softstyle Ultra 2.0 is a compact blood glucose meter for both self-testing and professional use. It needs no coding, ejects used strips automatically, and returns a result in 5 seconds from a 0.7 µL blood sample, storing up to 500 readings with date and time for tracking trends over time.",
    img: UltraImg,
    alt: "Softstyle Ultra 2.0 blood glucose meter",
    brochureHref: "/products/Softstyle Ultra/SoftStyle Ultra Brochure.pdf",
    brochureLabel: "Softstyle Ultra Brochure",
    keyFeatures: [
      { title: "Fast, small sample", text: "5 second test result from a 0.7 µL blood sample." },
      { title: "No coding, auto strip-ejection", text: "Fewer steps for the patient or operator, with a backlight LED for low-light readings." },
      { title: "500-reading memory", text: "Stores results with date and time so trends are easy to track." },
    ],
    specs: [
      { label: "Sample volume", value: "0.7 µL whole blood" },
      { label: "Test time", value: "5 seconds" },
      { label: "Measurement range", value: "1.1 - 33.3 mmol/L" },
      { label: "Memory", value: "500 records with date/time" },
      { label: "Power", value: "2 × AAA batteries" },
      { label: "Operating condition", value: "10 - 40°C, 20% - 80% RH" },
      { label: "Storage condition", value: "-20 - 55°C, RH ≤ 93%" },
      { label: "Dimensions", value: "90mm × 54mm × 13mm" },
      { label: "Weight", value: "48g (excluding batteries)" },
    ],
  },
];

export default products;

export function getProductBySlug(slug) {
  return products.find((product) => product.slug === slug);
}
